import { progressUpdated } from './feedbackSlice';

/**
 * Turns axios' `onUploadProgress` into progress in the store, under the
 * thunk's `requestId`: the activity bar fills with it instead of sliding.
 *
 * Several files going up in one thunk each take a `part`, and what is reported
 * is their sum. The entry goes away by itself when the thunk ends.
 *
 * `const report = uploadProgressReporter(dispatch, requestId, 'Subiendo el archivo');`
 * `await uploadRequest(formData, report());`
 *
 * @param {Function} dispatch
 * @param {string} requestId
 * @param {string} label
 * @returns {(part?: number|string) => (event: {loaded: number, total?: number}) => void}
 */
export const uploadProgressReporter = (dispatch, requestId, label) => {
  const parts = {};

  return (part = 0) => (event) => {
    if (!event?.total) return;
    parts[part] = { loaded: event.loaded, total: event.total };

    const sent = Object.values(parts);
    dispatch(
      progressUpdated({
        key: requestId,
        done: sent.reduce((sum, item) => sum + item.loaded, 0),
        total: sent.reduce((sum, item) => sum + item.total, 0),
        label,
      })
    );
  };
};
